/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import { DeactivateEtcCard200ResponseHolder } from './deactivate-etc-card200-response-holder';
// May contain unused imports in some cases
// @ts-ignore
import { DeactivateEtcCard200ResponseUserAccountGroup } from './deactivate-etc-card200-response-user-account-group';

/**
 * 
 * @export
 * @interface DeactivateEtcCard200Response
 */
export interface DeactivateEtcCard200Response {
    /**
     * ETC card ID
     * @type {string}
     * @memberof DeactivateEtcCard200Response
     */
    'cardId': string;
    /**
     * Card name (max 64 characters)
     * @type {string}
     * @memberof DeactivateEtcCard200Response
     */
    'cardLabel': string;
    /**
     * Card status
     * @type {string}
     * @memberof DeactivateEtcCard200Response
     */
    'cardStatus': DeactivateEtcCard200ResponseCardStatusEnum;
    /**
     * 
     * @type {DeactivateEtcCard200ResponseHolder}
     * @memberof DeactivateEtcCard200Response
     */
    'holder': DeactivateEtcCard200ResponseHolder;
    /**
     * 
     * @type {DeactivateEtcCard200ResponseUserAccountGroup}
     * @memberof DeactivateEtcCard200Response
     */
    'userAccountGroup'?: DeactivateEtcCard200ResponseUserAccountGroup | null;
    /**
     * User account ID
     * @type {string}
     * @memberof DeactivateEtcCard200Response
     */
    'userAccountId': string;
    /**
     * Last four digits of the ETC card ID for display
     * @type {string}
     * @memberof DeactivateEtcCard200Response
     */
    'etcIdLastFourDigits'?: string | null;
}

export const DeactivateEtcCard200ResponseCardStatusEnum = {
    issuing: 'ISSUING',
    active: 'ACTIVE',
    deactivated: 'DEACTIVATED'
} as const;

export type DeactivateEtcCard200ResponseCardStatusEnum = typeof DeactivateEtcCard200ResponseCardStatusEnum[keyof typeof DeactivateEtcCard200ResponseCardStatusEnum];


